import React from "react";
import '../PCBQuotationForm.css'

import RadioButtonGroup from "../../RadioButtonGroup/RadioButtonGroup";

let edgeQty = [
    {id: 1, checked: true, text: "1", name: "edgeQty"},
    {id: 2, checked: false, text: "2", name: "edgeQty"},
    {id: 3, checked: false, text: "3", name: "edgeQty"},
    {id: 4, checked: false, text: "4", name: "edgeQty"}
];

const EdgeQty = (props) => {

    return (
            <div className="row">
                <div className="pcb-details-div no-padding-left">
                    <div className="col-md-1 text-right content-item-heading">
                        {/*エッジ量*/}
                        エッジ数
                        {/*Edge Qty*/}
                        &nbsp; &nbsp;
                    </div>
                    <div className="btn-group col-md-3 pcb-details-div-items no-padding-left pull-left">
                        <RadioButtonGroup data={edgeQty} getParams={props.setPCBParams}/>
                    </div>
                </div>
            </div>
    )
};

export default EdgeQty;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBQuotationForm/PCBQuotationFormFields/EdgeQty.js